import { SvgIcon, SvgIconProps } from '@mui/material'

const Refresh = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49154 7.90583C6.42645 7.97092 6.42645 8.07645 6.49154 8.14153L7.90575 9.55575C7.97084 9.62083 8.07637 9.62083 8.14145 9.55575L9.55567 8.14153C9.62075 8.07644 9.62075 7.97092 9.55567 7.90583L8.14145 6.49162C8.07637 6.42653 7.97084 6.42653 7.90575 6.49162L6.49154 7.90583ZM5.78443 8.84864C5.32882 8.39303 5.32882 7.65434 5.78443 7.19872L7.19864 5.78451C7.65426 5.3289 8.39295 5.3289 8.84856 5.78451L10.2628 7.19872C10.7184 7.65433 10.7184 8.39303 10.2628 8.84864L8.84856 10.2629C8.39295 10.7185 7.65426 10.7185 7.19864 10.2629L5.78443 8.84864Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.21886 5.11082C3.27986 2.9758 5.43979 1.5 7.99701 1.5C10.5499 1.5 12.7581 2.97176 13.8211 5.11082C13.944 5.35811 13.8431 5.6582 13.5958 5.78109C13.3485 5.90398 13.0484 5.80314 12.9256 5.55585C12.025 3.74364 10.1558 2.5 7.99701 2.5C5.84257 2.5 4.01697 3.7396 3.11437 5.55585C2.99148 5.80314 2.69139 5.90398 2.4441 5.78109C2.19681 5.6582 2.09596 5.35811 2.21886 5.11082Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66675 2.16669C2.94289 2.16669 3.16675 2.39054 3.16675 2.66669V5.33335C3.16675 5.6095 2.94289 5.83335 2.66675 5.83335C2.39061 5.83335 2.16675 5.6095 2.16675 5.33335V2.66669C2.16675 2.39054 2.39061 2.16669 2.66675 2.16669Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16675 5.33331C2.16675 5.05717 2.39061 4.83331 2.66675 4.83331H4.92681C5.20295 4.83331 5.42681 5.05717 5.42681 5.33331C5.42681 5.60946 5.20295 5.83331 4.92681 5.83331H2.66675C2.39061 5.83331 2.16675 5.60946 2.16675 5.33331Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4441 10.2189C2.69139 10.096 2.99148 10.1969 3.11437 10.4442C4.01496 12.2564 5.88416 13.5 8.04295 13.5C10.1974 13.5 12.023 12.2604 12.9256 10.4442C13.0484 10.1969 13.3485 10.096 13.5958 10.2189C13.8431 10.3418 13.944 10.6419 13.8211 10.8892C12.7601 13.0242 10.6001 14.5 8.04295 14.5C5.49007 14.5 3.28187 13.0282 2.21886 10.8892C2.09596 10.6419 2.19681 10.3418 2.4441 10.2189Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3733 10.1667C13.6494 10.1667 13.8733 10.3905 13.8733 10.6667V13.3334C13.8733 13.6095 13.6494 13.8334 13.3733 13.8334C13.0971 13.8334 12.8733 13.6095 12.8733 13.3334V10.6667C12.8733 10.3905 13.0971 10.1667 13.3733 10.1667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6133 10.6667C10.6133 10.3905 10.8371 10.1667 11.1133 10.1667H13.3733C13.6495 10.1667 13.8733 10.3905 13.8733 10.6667C13.8733 10.9428 13.6495 11.1667 13.3733 11.1667H11.1133C10.8371 11.1667 10.6133 10.9428 10.6133 10.6667Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Refresh
